/* global ModalDialog, Swiper */
if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      resetZoom() {
        if (!this.swiper) { return; }
        this.swiper.slides.forEach((slide) => {
          slide.classList.remove("is-zoomed");
          const img = slide.querySelector(".swiper-zoom-container img");
          if (img) { img.style.transformOrigin = ""; }
        });
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(opener);
      }

      showActiveMedia(opener) {
        if (!this.swiper) {
          const swiperContainer = this.querySelector(".swiper");
          if (swiperContainer && typeof Swiper !== "undefined") {
            const slideCount = swiperContainer.querySelectorAll(".swiper-slide").length;

            this.swiper = new Swiper(swiperContainer, {
              loop: slideCount > 1,
              allowTouchMove: false,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              spaceBetween: 20,
              autoHeight: true,
              on: {
                slideChange: (swiper) => {
                  swiper.slides.forEach((slide) => {
                    slide.classList.remove("is-zoomed");
                    const img = slide.querySelector(".swiper-zoom-container img");
                    if (img) { img.style.transformOrigin = ""; }
                  });
                },
              },
            });

            swiperContainer.addEventListener("click", (e) => {
              const zoomContainer = e.target.closest(".swiper-zoom-container");
              if (!zoomContainer) { return; }
              const activeSlide = this.swiper.slides[this.swiper.activeIndex];
              if (!activeSlide) { return; }

              if (activeSlide.classList.contains("is-zoomed")) {
                activeSlide.classList.remove("is-zoomed");
              } else {
                const rect = zoomContainer.getBoundingClientRect();
                const x = ((e.clientX - rect.left) / rect.width) * 100;
                const y = ((e.clientY - rect.top) / rect.height) * 100;
                const img = zoomContainer.querySelector("img");
                if (img) { img.style.transformOrigin = `${x}% ${y}%`; }
                activeSlide.classList.add("is-zoomed");
              }
            });

            swiperContainer.addEventListener("pointerup", (e) => {
              e.stopPropagation();
            });
          }
        }

        const slideIndex = opener
          ? opener.getAttribute("data-slide-index")
          : null;
        if (slideIndex !== null && this.swiper) {
          this.resetZoom();
          this.swiper.slideTo(parseInt(slideIndex, 10), 0);
        }

        const activeMedia = this.swiper
          ? this.querySelectorAll(".swiper-slide")[
              parseInt(slideIndex, 10)
            ]?.querySelector("[data-media-id]")
          : null;
        if (activeMedia && activeMedia.nodeName === "DEFERRED-MEDIA") {
          const activeMediaTemplate = activeMedia.querySelector("template");
          const activeMediaContent = activeMediaTemplate
            ? activeMediaTemplate.content
            : null;
          if (
            activeMediaContent &&
            activeMediaContent.querySelector(".js-youtube")
          ) {
            activeMedia.loadContent();
          }
        }
      }
    },
  );
}
